module.exports = __webpack_public_path__ + "static/media/custom-ex-7.93b3c4bd.jpg";